/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const UnlinkIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="UnlinkIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M5.85355 4.14526L3.85477 2.14648L3.14767 2.85359L5.14645 4.85237L5.85355 4.14526Z"
                fill="currentColor"
              />
              <path d="M11.5 10.5H14V9.50004H11.5V10.5Z" fill="currentColor" />
              <path d="M2 5.49885H4.5V6.49885H2V5.49885Z" fill="currentColor" />
              <path
                d="M10.1464 11.8536L12.1464 13.8536L12.8536 13.1465L10.8536 11.1465L10.1464 11.8536Z"
                fill="currentColor"
              />
              <path
                d="M5.85355 7.85384L4.85355 8.85384C4.22039 9.487 4.22039 10.5136 4.85355 11.1467C5.48672 11.7799 6.51328 11.7799 7.14644 11.1467L8.14645 10.1467L8.85355 10.8538L7.85355 11.8538C6.82986 12.8775 5.17014 12.8775 4.14645 11.8538C3.12276 10.8301 3.12276 9.17042 4.14645 8.14673L5.14645 7.14673L5.85355 7.85384Z"
                fill="currentColor"
              />
              <path
                d="M11.8536 4.14673C10.8299 3.12304 9.17014 3.12304 8.14645 4.14673L7.14645 5.14673L7.85355 5.85384L8.85355 4.85383C9.48672 4.22067 10.5133 4.22067 11.1464 4.85384C11.7796 5.487 11.7796 6.51356 11.1464 7.14673L10.1464 8.14673L10.8536 8.85384L11.8536 7.85383C12.8772 6.83014 12.8772 5.17042 11.8536 4.14673Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

UnlinkIcon.tags = [
  'disconnect',
  'break',
  'stop',
  'chain',
  'link',
  'separate',
  'unlock',
];

UnlinkIcon.category = 'General Icons';

UnlinkIcon.iconSize = 16;
